import { TRANSACTION_TYPE } from '../commission-codes';

export enum BMS_NOTE_TYPE {
  CREDIT_NOTE = 'C',
  DEBIT_NOTE = 'D',
}

export enum CREDIT_NOTE_TRANSACTION_TYPE {
  GET_PREMIUM = 'GP',
  GET_COMMISSION = 'GC',
  NEW_BUSINESS = 'NB',
  RENEWAL = 'R',
  ENDORSEMENT = 'E',
  CANCELLATION = 'C',
}

export enum CREDIT_NOTE_TRANSACTION_STATUS {
  PAYMENT_RECEIVED = 'PR',
  PENDING = 'PE',
  PARTIAL_RECEIVED = 'PA',
}

export enum DEBIT_NOTE_TRANSACTION_TYPE {
  RETURN_PREMIUM = 'RP',
  RETURN_COMMISSION = 'RC',
  NEW_BUSINESS = 'NB',
  RENEWAL = 'R',
  ENDORSEMENT = 'E',
  CANCELLATION = 'C',
}

export const TRANSACTION_TYPE_MAP = {
  [TRANSACTION_TYPE.NEW_BUSINESS]: {
    credit: CREDIT_NOTE_TRANSACTION_TYPE.NEW_BUSINESS,
    debit: DEBIT_NOTE_TRANSACTION_TYPE.NEW_BUSINESS,
  },
  [TRANSACTION_TYPE.RENEWAL]: {
    credit: CREDIT_NOTE_TRANSACTION_TYPE.RENEWAL,
    debit: DEBIT_NOTE_TRANSACTION_TYPE.RENEWAL,
  },
  [TRANSACTION_TYPE.ENDORSEMENT]: {
    credit: CREDIT_NOTE_TRANSACTION_TYPE.ENDORSEMENT,
    debit: DEBIT_NOTE_TRANSACTION_TYPE.ENDORSEMENT,
  },
  [TRANSACTION_TYPE.CANCELLATION]: {
    credit: CREDIT_NOTE_TRANSACTION_TYPE.CANCELLATION,
    debit: DEBIT_NOTE_TRANSACTION_TYPE.CANCELLATION,
  },
};

export enum DEBIT_NOTE_TRANSACTION_STATUS {
  PAID = 'P',
  PENDING = 'PE',
  PARTIAL = 'PA',
}

export enum CREDIT_NOTE_STATUS {
  PENDING = 'P',
  PAYMENT_RECEIVED_PARTIALLY = 'PRP',
  PAYMENT_RECEIVED = 'PR',
}

export enum DEBIT_NOTE_STATUS {
  PENDING = 'P',
  PAID_PARTIALLY = 'PP',
  PAID = 'PA',
}

export enum TRANSACTION_PARTY {
  BROKER = 'B',
}
